import { render, staticRenderFns } from "./registrationInfo.vue?vue&type=template&id=449d36a6&scoped=true&"
import script from "./registrationInfo.vue?vue&type=script&lang=js&"
export * from "./registrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d36a6",
  null
  
)

export default component.exports